import { useEffect, useState } from "react";
import { ITsaScreener } from "../../../globals/interfaces";
import apiClient from "../../../apiClient";
import _ from "lodash";

export type ScreenersMap = Record<string, boolean>;
export type AddScreenerData = Omit<ITsaScreener, 'id'>;
export type AddScreener = (data: AddScreenerData) => Promise<boolean>;

export default function useData(s_unit: string, creator: string) {
    const [screeners, setScreeners] = useState<Array<ITsaScreener>>([]);
    const [selectedScreener, setSelectedScreener] = useState<ITsaScreener>();

    useEffect(() => {
        getData();
    }, [s_unit]);

    const getData = async () => {
        try {
            const res = await apiClient.get(`/tsaScreener/${s_unit}`);
            setScreeners(res.data);
        } catch (err) {
            alert(err);
        }
    }

    const addScreener: AddScreener = async (data: AddScreenerData) => {
        try {
            const res = await apiClient.post(`/tsaScreener`, data);
            setScreeners(prev => {
                return [...prev, res.data];
            });
            setSelectedScreener(res.data);
            return true;
        } catch (err) {
            alert(err);
            return false;
        }
    }

    const deleteScreener = async (id: number): Promise<boolean> => {
        try {
            await apiClient.delete(`/tsaScreener/${id}`);
            setScreeners(prev => {
                return prev.filter(screener => screener.id !== id);
            });
            return true;
        } catch (err) {
            alert(err);
            return false;
        }
    }

    return {
        screeners,
        addScreener,
        deleteScreener,
        selectedScreener,
        setSelectedScreener
    }
}